(function ($) {

    // Captura de UTMs para os formulários (rodapé e contato).
    // - Lê utm_source / utm_medium / utm_campaign da URL
    // - Guarda na sessão do navegador (o visitante costuma navegar antes de enviar)
    // - Preenche os campos hidden do CF7 no load, no submit e após o reset do CF7
    //
    // Depende de: jQuery.

    var PARAMS        = ['utm_source', 'utm_medium', 'utm_campaign'];
    var STORAGE_KEY   = 'mpUtm';
    var SELECTOR_FORM = '.wpcf7-form';
    var MAX_LENGTH    = 255;

    // Fallback pra quando o sessionStorage está indisponível (aba anônima, cookies bloqueados)
    var memory = null;

    function sanitize(value) {
        return String(value || '')
            .replace(/[<>"']/g, '')
            .replace(/\s+/g, ' ')
            .replace(/^\s+|\s+$/g, '')
            .substring(0, MAX_LENGTH);
    }

    function readFromUrl() {
        var query = window.location.search.replace(/^\?/, '');
        if (!query) return null;

        var parts = query.split('&');
        var data  = {};
        var found = false;

        for (var i = 0; i < parts.length; i++) {
            var pair = parts[i].split('=');
            var key  = '';

            try {
                key = decodeURIComponent(pair[0] || '').toLowerCase();
            } catch (e) {
                key = (pair[0] || '').toLowerCase();
            }

            if ($.inArray(key, PARAMS) === -1) continue;

            var raw = pair.slice(1).join('=').replace(/\+/g, ' ');
            var val = '';

            try {
                val = decodeURIComponent(raw);
            } catch (e) {
                val = raw;
            }

            val = sanitize(val);

            if (val !== '') {
                data[key] = val;
                found     = true;
            }
        }

        return found ? data : null;
    }

    function store(data) {
        memory = data;
        try {
            window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
        } catch (e) {}
    }

    function retrieve() {
        if (memory) return memory;
        try {
            var raw = window.sessionStorage.getItem(STORAGE_KEY);
            if (raw) memory = JSON.parse(raw);
        } catch (e) {}
        return memory;
    }

    function fillFields(data) {
        if (!data) return;
        for (var i = 0; i < PARAMS.length; i++) {
            var key = PARAMS[i];
            $('input[name="' + key + '"]').val(data[key] || '');
        }
    }

    $(function () {
        // Chegou link parametrizado: a origem mais recente substitui a anterior (last click)
        var fromUrl = readFromUrl();
        if (fromUrl) store(fromUrl);

        var data = retrieve();
        if (!data) return;

        fillFields(data);

        // O CF7 limpa os campos depois do envio; repõe pra um eventual segundo envio
        document.addEventListener('wpcf7reset', function () {
            fillFields(retrieve());
        }, false);

        document.addEventListener('wpcf7mailsent', function () {
            fillFields(retrieve());
        }, false);

        // Última garantia antes de submeter
        $(document).on('submit', SELECTOR_FORM, function () {
            fillFields(retrieve());
        });
    });

})(jQuery);
